import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.224 7.93a5.054 5.054 0 0 1 4.867-3.71 5.057 5.057 0 0 1 5.054 5.054v.049A3.246 3.246 0 0 1 18 12.54a3.244 3.244 0 0 1-3.24 3.24h-1.857a.7.7 0 1 1 0-1.4h1.857c1.013 0 1.84-.828 1.84-1.84 0-1.013-.827-1.84-1.84-1.84h-.315a.7.7 0 0 1-.7-.7v-.726A3.657 3.657 0 0 0 10.09 5.62a3.655 3.655 0 0 0-3.6 3.059.7.7 0 0 1-.655.585 2.557 2.557 0 0 0-2.436 2.55 2.566 2.566 0 0 0 2.565 2.566h1.132a.7.7 0 0 1 0 1.4H5.965A3.966 3.966 0 0 1 2 11.814a3.954 3.954 0 0 1 3.224-3.883Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.519 14.77a.7.7 0 0 0 .962 0l1.963-1.858a.7.7 0 0 0-.963-1.017l-.781.74V9.057a.7.7 0 0 0-1.4 0v3.578l-.781-.74a.7.7 0 1 0-.963 1.017L9.52 14.77Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=DownloadIcon20.js.map